import { UserCardFragmentFragment } from '@/__generated__/graphql';
import { useAdminUsersSearch } from '@/components/users/use-admin-users-search';
import { UsersMultiSelectComboboxBase } from './users-multi-select-combobox-base';

export const AdminUsersMultiSelectCombobox = ({
  wrapperClassName,
  selectedUsers,
  setSelectedUsers,
  error,
  setError,
}: {
  wrapperClassName?: string;
  selectedUsers: UserCardFragmentFragment[];
  setSelectedUsers: (users: UserCardFragmentFragment[]) => void;
  error?: string;
  setError?: (error?: string) => void;
}) => {
  const { users, onValueChange, isLoading } = useAdminUsersSearch();

  return (
    <UsersMultiSelectComboboxBase
      wrapperClassName={wrapperClassName}
      selectedUsers={selectedUsers}
      setSelectedUsers={setSelectedUsers}
      error={error}
      setError={setError}
      users={users}
      onInputChange={onValueChange}
      isLoading={isLoading}
      label="Name, username or email"
    />
  );
};
